import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modify-object-group',
  templateUrl: './modify-object-group.component.html',
  styleUrls: ['./modify-object-group.component.css']
})
export class ModifyObjectGroupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
